/* assets/ahm-hero-wall.js — home hero "Gallery light" (the wall). Shopify version of the mockup's js/hero-wall.js.
   sections/home-hero.liquid renders the FIRST slide (photo + caption) on the server and inlines every slide's
   car record as JSON (<script data-hx-data>). This script:
     - adds the other slides (photos load lazily, the next one is warmed before it is shown);
     - samples each photo's left edge (7 bands) and mean tone from a 48px copy, so the colour field the photo
       dissolves into is the photo's own; defaults in the CSS hold until the sample lands (or if it fails);
     - runs a calm autoplay (~7s) that stops on hover, on keyboard focus in the controls, in a hidden tab,
       when the hero is off screen, when the viewer pauses it, and entirely under reduced motion.
   It does not wait for the stock feed: all it needs is inlined. Works for 0, 1 and up to 6 slides. */
(function () {
  'use strict';
  var HOLD = 7000;

  function todayYMD() { var d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function hex(r, g, b) { return '#' + [r, g, b].map(function (v) { v = Math.max(0, Math.min(255, Math.round(v))); return (v < 16 ? '0' : '') + v.toString(16); }).join(''); }

  function Hero(el) {
    var M = window.M;
    var S = { el: el, slides: [], idx: 0, timer: 0, userPaused: false, hovering: false, focused: false, visible: true };
    function q(sel) { return el.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }

    /* ---------- data ---------- */
    var dataEl = q('[data-hx-data]');
    var raw = [];
    try { raw = JSON.parse((dataEl && dataEl.textContent) || '[]') || []; } catch (e) { raw = []; }
    var today = todayYMD();
    raw.forEach(function (d) {
      var c = d && d.car; if (!c || !c.photos || !c.photos.length || !c.photos[0].m) return;
      c.status = c.status === 'way' ? 'way' : 'in';
      c.eta = c.eta || '';
      c.etaFuture = !!(c.eta && String(c.eta).slice(0, 10) > today);
      c.title = c.title || [c.year, c.make, c.model].filter(Boolean).join(' ');
      S.slides.push({ car: c, photo: c.photos[0], sample: d.s || '' });
    });
    if (!S.slides.length) return null;

    /* ---------- markup ---------- */
    // Hidden slides are stacked (opacity 0) inside the viewport, so loading="lazy" does not hold them back:
    // they carry data-src / data-srcset and get a real source only when they are shown or are next (arm()).
    function slideHTML(s, n) {
      var im = M.img(s.photo, { sizes: '(max-width: 900px) 100vw, 70vw', alt: '', cls: 'hx-photo' })
        .replace(' src="', ' data-src="').replace(' srcset="', ' data-srcset="');
      return '<div class="hx-slide" data-n="' + n + '" aria-hidden="true">' +
        '<div class="hx-field" aria-hidden="true"></div>' +
        '<div class="hx-plate">' + im + '</div>' +
      '</div>';
    }
    function arm(im) {
      if (!im || !im.hasAttribute('data-src')) return;
      im.loading = 'eager';
      if (im.hasAttribute('data-srcset')) { im.setAttribute('srcset', im.getAttribute('data-srcset')); im.removeAttribute('data-srcset'); }
      im.setAttribute('src', im.getAttribute('data-src')); im.removeAttribute('data-src');
    }
    function caption(s) {
      var a = M.avail(s.car);
      return '<a class="hx-cap" href="' + M.esc(s.car.url) + '">' +
        '<span class="hx-cap-t">' + M.esc(s.car.title) + '<span class="hx-cap-arr" aria-hidden="true">' + M.icon('arrow-right', { size: 16 }) + '</span></span>' +
        '<span class="hx-cap-s"><span class="' + a.dot + '" aria-hidden="true"></span><span><b>' + M.esc(a.word) + '</b>' +
          (a.where ? ' · ' + M.esc(a.where) : '') + (s.car.ref ? ' <span class="hx-cap-ref">· Ref ' + M.esc(s.car.ref) + '</span>' : '') + '</span></span>' +
      '</a>';
    }

    /* ---------- the colour field: sampled from the photo's own left edge ---------- */
    function sample(n) {
      var s = S.slides[n], f = qa('.hx-slide')[n];
      if (!s || !f || s.sampled || !s.sample) return;
      s.sampled = true;
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight; if (!w || !h) return;
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          var g = cv.getContext('2d', { willReadFrequently: true }); g.drawImage(im, 0, 0);
          var d = g.getImageData(0, 0, w, h).data;
          var edge = Math.max(1, Math.round(w * 0.06));
          for (var b = 0; b < 7; b++) {
            var y0 = Math.floor(h * b / 7), y1 = Math.max(y0 + 1, Math.floor(h * (b + 1) / 7));
            var r = 0, gg = 0, bb = 0, k = 0;
            for (var y = y0; y < y1 && y < h; y++) for (var x = 0; x < edge; x++) { var i = (y * w + x) * 4; r += d[i]; gg += d[i + 1]; bb += d[i + 2]; k++; }
            if (k) f.style.setProperty('--e' + b, hex(r / k, gg / k, bb / k));
          }
          var mr = 0, mg = 0, mb = 0, mk = 0;
          for (var j = 0; j < d.length; j += 4) { mr += d[j]; mg += d[j + 1]; mb += d[j + 2]; mk++; }
          if (mk) f.style.setProperty('--mean', hex(mr / mk, mg / mk, mb / mk));
        } catch (e) { /* a cross-origin image taints the canvas: the CSS default tones stay */ }
      };
      im.src = s.sample;
    }

    /* ---------- show / rotate ---------- */
    function show(n) {
      var cap = q('[data-hx-caption]');
      S.idx = (n + S.slides.length) % S.slides.length;
      var next = (S.idx + 1) % S.slides.length;
      qa('.hx-slide').forEach(function (f) {
        var k = +f.getAttribute('data-n'), on = k === S.idx, im = f.querySelector('.hx-photo');
        f.classList.toggle('is-on', on);
        if (on) f.removeAttribute('aria-hidden'); else f.setAttribute('aria-hidden', 'true');
        if (im) {
          im.alt = on ? (S.slides[k].photo.alt || S.slides[k].car.title) : '';
          if (on || k === next) arm(im); // this one, and warm the next
        }
      });
      sample(S.idx); sample(next);
      qa('[data-hx-dot]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-hx-dot') === S.idx)); });
      if (cap) cap.innerHTML = caption(S.slides[S.idx]);
      schedule();
    }
    function running() {
      return !M.reducedMotion && !S.userPaused && !S.hovering && !S.focused && S.visible && !document.hidden && S.slides.length > 1 && document.contains(el);
    }
    function schedule() {
      clearTimeout(S.timer);
      if (!running()) return;
      S.timer = setTimeout(function () { show(S.idx + 1); }, HOLD);
    }
    function setPauseBtn() {
      var b = q('[data-hx-pause]'); if (!b) return;
      var paused = S.userPaused || M.reducedMotion;
      b.setAttribute('aria-pressed', String(paused));
      b.setAttribute('aria-label', paused ? 'Play the slideshow' : 'Pause the slideshow');
      b.innerHTML = paused
        ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M8 5.5v13l10.5-6.5z"/></svg>'
        : '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><rect x="7" y="5.5" width="3.4" height="13" rx="1"/><rect x="13.6" y="5.5" width="3.4" height="13" rx="1"/></svg>';
    }

    /* ---------- build: slide 0 is already in the page (server-rendered) ---------- */
    var host = q('[data-hx-slides]');
    var first = host && host.querySelector('.hx-slide');
    if (!host) return null;
    if (!first) { host.innerHTML = slideHTML(S.slides[0], 0); first = host.firstChild; first.classList.add('is-on'); first.removeAttribute('aria-hidden'); }
    var rest = S.slides.slice(1).map(function (s, i) { return slideHTML(s, i + 1); }).join('');
    if (rest) host.insertAdjacentHTML('beforeend', rest);

    var ctrl = q('[data-hx-ctrl]'), dots = q('[data-hx-dots]');
    if (dots) {
      dots.innerHTML = S.slides.map(function (s, n) {
        return '<button type="button" class="hx-dot" data-hx-dot="' + n + '" aria-label="Show the ' + M.esc(s.car.title) + '" aria-pressed="' + (n === 0) + '"><span></span></button>';
      }).join('');
    }
    if (ctrl) ctrl.hidden = S.slides.length < 2;
    setPauseBtn();

    el.addEventListener('click', function (e) {
      var d = e.target.closest('[data-hx-dot]');
      if (d) { show(+d.getAttribute('data-hx-dot')); return; }
      if (e.target.closest('[data-hx-pause]')) {
        if (M.reducedMotion) { M.toast('The slideshow stays still because your device asks for reduced motion. Use the dots to change car.'); return; }
        S.userPaused = !S.userPaused; setPauseBtn(); schedule();
      }
    });
    el.addEventListener('mouseenter', function () { S.hovering = true; schedule(); });
    el.addEventListener('mouseleave', function () { S.hovering = false; schedule(); });
    // keyboard focus on the controls holds the car (a mouse click leaves focus behind, so only :focus-visible counts)
    el.addEventListener('focusin', function (e) {
      var t = e.target, fv = false; try { fv = t.matches(':focus-visible'); } catch (x) { fv = true; }
      S.focused = !!(t.closest && t.closest('.hx-ui')) && fv; schedule();
    });
    el.addEventListener('focusout', function (e) { if (!e.relatedTarget || !el.contains(e.relatedTarget)) { S.focused = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) { S.visible = ents[0].isIntersecting; schedule(); }, { threshold: 0.25 }).observe(el);
    }

    // slide 0's caption is server-rendered; re-render it only to pick up the viewer's local "due" date logic
    show(0);
    return { stop: function () { clearTimeout(S.timer); } };
  }

  var live = [];
  function initAll(root) {
    if (!window.M) return;
    (root || document).querySelectorAll('[data-hx-wall]').forEach(function (el) {
      if (el.__hx) return;
      el.__hx = 1;
      var h = Hero(el); if (h) live.push(h);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // theme editor: a re-rendered section brings fresh markup (the old instance's element is gone)
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
